import { Observable } from 'rxjs';
import { TagEntityType } from '@features/opportunities/services/tag.service';
import { Tag } from '@shared/models/tag';
import { Task } from '../models/task';

export interface SearchOptions {
  searchString: string;
}

export abstract class TaskService {
  abstract entityId$: Observable<string>;
  abstract tagEntityType$: Observable<TagEntityType>;
  abstract getTasks(
    entityId: string,
    options: SearchOptions
  ): Observable<Task.Model[]>;
  abstract getTaskDefinition(): Observable<Task.Definition>;
  abstract getTaskForEdit(
    entityId: string,
    taskId: string
  ): Observable<Task.Model>;
  abstract updateTask(
    entityId: string,
    taskId: string,
    change: any
  ): Observable<any>;
  abstract completeTask(entityId: string, taskId: string): Observable<any>;
  abstract deleteTask(entityId: string, taskId: string): Observable<any>;
  abstract markTaskAsReviewed(
    entityId: string,
    taskId: string
  ): Observable<any>;
  abstract getTaskTags(
    entityId: string,
    taskId: string
  ): Observable<Tag[]>;
}
